function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10,
  strokeWidth: 5.69,
  d: "M31.5 0v48.79"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M49.08 41H13.93L31.5 64l17.58-23z",
  fill: "currentColor"
});

function SvgArrowDownLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2NCA2NCI+CiAgPHBhdGggZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLXdpZHRoPSI1LjY5IiBkPSJNMzEuNSAwdjQ4Ljc5Ii8+CiAgPHBhdGggZD0iTTQ5LjA4IDQxSDEzLjkzTDMxLjUgNjRsMTcuNTgtMjN6IiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+";
export { SvgArrowDownLine as ReactComponent };